import { render, staticRenderFns } from "./fdInventory51.vue?vue&type=template&id=473925f8"
import script from "./fdInventory51.vue?vue&type=script&lang=js"
export * from "./fdInventory51.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports